// this saga is used for showing the LoginScreen when a 401 error is received
// if login is successful, it will reattempt the request
// if login fails, it will return the error
export function* callApi(apiCall) {
  const response = yield apiCall;

  //TODO add there condition if responce is 401
  return response;
}
